import { render, staticRenderFns } from "./CreateLastMonth.vue?vue&type=template&id=551a905e&lang=pug"
import script from "./CreateLastMonth.vue?vue&type=script&lang=js"
export * from "./CreateLastMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports